import TariffsPage from './TariffsPage';

export default TariffsPage;
